export default {
      id: "help-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#help-usage",
      toString: function () {
        return this.url;
      }
    }